module.exports = __webpack_public_path__ + "img/map-marker.fac42087.svg";